import { HStack } from "@chakra-ui/react"
import { GearIcon } from "@pathwright/pathicons"
import Link from "@pathwright/ux/src/components/link/Link"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import moment from "moment"
import { getGroupSubscriptionLinkProps } from "../../mentor-group/utils"
import { useShareDataContext } from "../shared/ShareDataContextProvider"
import Gate from "./Gate"
import useGatedShareAccessKey from "./useGatedShareAccessKey"

const GroupShareGate = () => {
  const { group, meta, permissions } = useShareDataContext()
  const { tc, tca } = useTranslate()
  const gatedReason = permissions[useGatedShareAccessKey()]?.gated_reason

  switch (gatedReason) {
    case "GROUP_SUBSCRIPTION_INACTIVE":
      return (
        <Gate
          title={tca("Access Expired")}
          description={tc(
            `Access to {{cohortName}} expired on {{cohortAccessEnds}}`,
            {
              cohortName: meta.title,
              cohortAccessEnds: moment(meta.groupSubscriptionEnds).format(
                "MMM Do, YYYY"
              )
            }
          )}
        >
          {permissions?.allow_manage && (
            <Link
              {...getGroupSubscriptionLinkProps(group?.group_subscription)}
              colorPalette="gray"
              variant="underline"
            >
              <HStack gap={1}>
                <GearIcon size="1em" />
                <span>{tc("Manage subscription")}</span>
              </HStack>
            </Link>
          )}
        </Gate>
      )
    case "GROUP_SEATS_FILLED":
      return (
        <Gate
          title={tca("Seat Count Reached")}
          description={tc(`{{cohortName}} has no more remaining seats`, {
            cohortName: meta.title
          })}
        >
          {permissions?.allow_manage && (
            <Link
              {...getGroupSubscriptionLinkProps(group?.group_subscription)}
              colorPalette="gray"
              variant="underline"
            >
              <HStack gap={1}>
                <GearIcon size="1em" />
                <span>{tc("Manage subscription")}</span>
              </HStack>
            </Link>
          )}
        </Gate>
      )
  }

  // If typescript, we should ensure the switch case is exhausted.
  return null
}

export default GroupShareGate
